import React from 'react'
import { Row, Col } from 'react-bootstrap'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IOurServices } from '../../types/api/homeApi';
import { NoData } from '../common/NoData';
import { useTranslation } from 'react-i18next';
import { IOurService, ISubOurService } from '../../types/features/multiLanguageSlice';

const Services: React.FC<{ our_services: Array<IOurServices> }> = ({ our_services }) => {
    const {t} = useTranslation()

const our_services_json = t('home.our_service.our_services', { returnObjects: true })  as ISubOurService[];

    return (
        <section className='services inner-padding'>
            <div className='service-image'>
                <img src={require('../../assets/images/servi-01.jpg')} alt='demo' />
            </div>
            <div className='container'>
                <Row className='align-items-center'>
                    <Col md={7} lg={6} xl={9}>
                        <div className='services-title'>
                            <h3 className='title-highlight'>{t('home.our_service.title')}</h3>
                        </div>
                        <div className='service-list'>
                            <ul>
                                {our_services && our_services.length ?
                                    our_services.map((service: IOurServices, index: number) => (
                                        <li key={"our_services_" + index}>
                                            <div className='services-icon'>
                                                <img src={`${service.photo}`} alt='icon' />
                                            </div>
                                            <div className='service-detauils'>
                                                <h4>{our_services_json && our_services_json.length>0 && our_services_json[index].title}</h4>
                                                <p>{our_services_json && our_services_json.length>0 && our_services_json[index].description}</p>
                                            </div>
                                        </li>
                                    ))
                                    : <NoData message="Oops, No Service Data Found!!" />}
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default Services